import { PropTypes } from "@l2r-front/l2r-proptypes"
import { InfoItemButton } from "@l2r-front/l2r-ui"


export const RoadInfoItem = (props) => {

    const {
        children,
        className,
        ...roadInfoProps
    } = props

    return (
        <InfoItemButton className={className} {...roadInfoProps} >
            {children}
        </InfoItemButton>
    )
}

RoadInfoItem.propTypes = InfoItemButton.propTypes & {
    children: PropTypes.node,
}